module.exports = __webpack_public_path__ + "static/media/layer6.5b1a7936.svg";